<template>
    <div style="background-color: rgb(253, 244, 214); position: relative; border-radius: 4px; padding: 20px 20px;">
        <h2 v-if="title" class="search__filter-title">{{title}}</h2>
        <div class="search-outer">
            <div class="fias-search-status">
                <i v-if="loading" class="lnr lnr-sync rotating"></i>
                <i v-else class="lnr lnr-magnifier"></i>
            </div>

            <div
                v-if="registry == 'fias'"
                @click="() => {searchHandle(request)}"
                class="fias-search-submit">Найти</div>

            <div
                class="fias-search-erase"
                @click="reset"
                v-if="request"
                :style="{right: this.registry != 'fias' ? '0' : '140px' }">
                <i class="lnr lnr-cross"></i>
            </div>

            <div class="fias-search-input">
                <input
                    v-if="registry == 'fias'"
                    @keypress.enter="searchHandle(request)"
                    v-model="request"
                    type="text"
                    :placeholder="inputPlaceholder"
                />
                <input
                    v-else
                    @input="timeoutRequest(request)"
                    v-model="request"
                    type="text"
                    :placeholder="inputPlaceholder"
                />
            </div>
        </div>

        <div>
            <code v-for="(e,i) in checkedClassificator.filter((e, i) => i < 10)" :key="i">
                <template v-if="registry == 'okved'">
                    {{e.code.replace('2014:', '')}} - {{e.full_title ? e.full_title : e.title}}
                </template>
                <template v-else>
                    {{e.full_title ? e.full_title : e.title}}
                </template>
                <span @click="deleteItemFromChecked(e.id)" style="vertical-align: middle; cursor: pointer;">
                    <i class="lnr lnr-cross"></i>
                </span>
            </code>
            <code v-if="checkedClassificator.length > 10">
                Всего {{checkedClassificator.length}} и ещё {{checkedClassificator.length - 10}}...
            </code>
        </div>

        <div class="search-filter">
            <tree :registry="registry" :treeArray="treeArray"/>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import tree from './tree.vue'

export default {
    props: {
        registry: String,
        title: String,
        model: Object,
        inputPlaceholder: String
    },
    components: { tree },
    data(){
        return {
            loading: false,
            inputTimeout: null,
            request: ''
        }
    },
    methods: {
        deleteItemFromChecked(id){
            const registry = this.$props.registry
            this.$store.dispatch('search/deleteItemFromChecked', { registry, id })
        },
        reset(){
            this.request = ''
            this.searchHandle('')
        },
        timeoutRequest(request) {
            clearTimeout(this.inputTimeout)

            this.inputTimeout = setTimeout(() => {
                this.searchHandle(request)
            }, 500)
        },
        searchHandle(request){
            this.loading = true
            this.$store.dispatch('search/getClassificator', {
                registry: this.$props.registry, request
            }).then(() => {
                this.loading = false
            })
        }
    },
    computed: {
        treeArray() { return this.$store.state.search.classificator[this.$props.registry] },
        rectype(){ return this.$store.state.search.filterData.rectype },
        checkedClassificator(){ return this.$store.state.search.filterData.checkedClassificator[this.$props.registry] },
        allSelectedRowsFromVuexStore() { return this.$store.state.search.classificator[this.$props.registry] },
        thisClassificatorStore(){ return this.$store.state.search.classificator[this.$props.registry]}
    }
}
</script>

<style>
.tree-node {
    font-size: 14px;
}
/* ul.tree-root {
    margin-top: 20px;
} */
/* .tree-children,
.tree-arrow:after,
.tree-checkbox,
.tree-checkbox:after {
    transition: none !important;
} */
.tree-checkbox {
    border: solid 2px #F7CA18;
    border-radius: 0;
    width: 18px !important;
    height: 18px !important;
}
.tree--small .tree-checkbox.checked:after {
    left: 4px;
    top: 0px;
    height: 9px;
    width: 5px;
}
.search__filter-title {
    text-align: center;
    font-family: 'PT Serif', serif;
    font-size: 32px;
}
.search-outer {
    position: relative;
}
.fias-search { width: 100%; min-width: 300px; margin: 0 auto; position: relative; }
.search-outer { background: #fff; height: 40px; background: transparent; width: 100%; margin: 0 auto; }
.fias-search-status { width: 40px; height: 40px; line-height: 43px; font-size: 18px; text-align: center; float: left; border: solid 1px #999; border-radius: 4px 0 0 4px; border-right: none;  }
.fias-search-submit {
    width: 140px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    border: solid 1px #999;
    border-radius: 0 4px 4px 0;
    border-left: solid 1px #999;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
}
.fias-search-erase {
    position: absolute;
    top: 0;
    right: 140px;
    width: 40px;
    height: 40px;
    line-height: 45px;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
}
.fias-search-erase:hover { color: #c00; }
.fias-search-submit:hover { background: #f5f5f5; }
.fias-search-input {
    margin-left: 40px;
    height: 40px;
    border-top: solid 1px #999;
    border-bottom: solid 1px #999;
    border-right: solid 1px #999;
    border-radius: 0 4px 4px 0;
}
.fias-search-input input[type="text"] { display: block; width: 100%; font-family: Helvetica, Arial, sans-serif; height: 40px; line-height: 40px; font-size: 16px; font-weight: 300; border: none; background: transparent; }
.fias-search-result { margin: 0 !important; padding: 0 !important; column-width: 250px; column-gap: 20px; }
.fias-search-result li { display: inline-block; padding-left: 30px; width: 250px; margin-top: 10px; font-size: 16px; }
.fias-search-result li span { color: rgba(30, 139, 195,1.0); border-bottom: dashed 1px rgba(30, 139, 195,0.2); cursor: pointer; }
.fias-search-result li span:hover { color: rgba(255,50,50,1.0); border-color: rgba(255,50,50,0.2); }
.fias-search-result li span.off { color: #000; border: none; cursor: default; }
.fias-search-result li span.off:hover { color: #000; }
.fias-search-result li .add { top: 2px; left: 0; display: inline-block; width: 18px; height: 18px; border: solid 2px #F7CA18; text-align: center; line-height: 18px; background: #fff; cursor: pointer; font-size: 10px;margin: 0px 12px -4px -30px; }
.fias-search-result li .add i { display: none; }
.fias-search-result li .add.on { background: #F7CA18; }
.fias-search-result li .add.on i { display: inline; }

.fias-search-selected { margin: 0; padding: 0; width: 100%; margin: 0 auto; }
.fias-search-selected li { display: inline-block; white-space: nowrap; margin-top: 5px; background: #fff; border: solid 1px #ddd; border-radius: 3px; padding: 2px 5px; font-size: 11px; line-height: 20px; margin-right: 5px; }
.fias-search-selected li .del { display: inline; color: #900; cursor: pointer;  font-size: 13px; margin-left: 5px; position: relative; top: 2px; }
.fias-search-selected li .del:hover { color: #f00; }

</style>

<style scoped>
.lnr-sync, .lnr-magnifier {
    display: inline-block;
}
.tree-node {
    font-size: 14px;
}
code {
    display: inline-block;
    font-size: 12px;
    margin-right: 3px;
}
.search-filter {
    max-height: 700px;
    overflow-y: auto;
    margin-top: 15px;
}
</style>